import { useEffect, useState } from 'react';
import { getActiveSports } from '../services/predictions';

/**
 * Sports in season right now, from sports_seasons (GET /predictions/active-sports).
 *
 * Pages used to hardcode their sport buttons, so MLB stayed on the Edges and
 * Streak tabs after its season ended. Pass the sports a view can show
 * (`supported`, in display order); the hook returns the ones in season.
 *
 * Until the request answers, and if it fails, every supported sport is
 * returned, so a slow or failed call shows the old buttons instead of none.
 */
const LABELS = {
  mlb: 'MLB', nba: 'NBA', nhl: 'NHL', nfl: 'NFL', ncaa_f: 'NCAAF', ncaa_b: 'NCAAB',
};

let cached = null; // one request per page load, shared by every caller

export default function useActiveSports(supported) {
  const [active, setActive] = useState(cached);

  useEffect(() => {
    if (cached) return;
    let alive = true;
    getActiveSports()
      .then((rows) => {
        cached = rows.map((r) => r.sport);
        if (alive) setActive(cached);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const ids = active ? supported.filter((s) => active.includes(s)) : supported;
  return {
    sports: ids.map((id) => ({ id, label: LABELS[id] || id.toUpperCase() })),
    loaded: active !== null,
  };
}
